import moment from 'moment';
import { IOrderHistoryModel } from 'entities/OrderHistory/OrderHistory.models';

const reorderMaxAvailableHoursInterval = 24;

export const isOrderRateTimeExpired = (orderHistoryItem: IOrderHistoryModel | null): boolean => {
  const { pickedUpAt } = orderHistoryItem || {};
  return moment().diff(moment(pickedUpAt), 'hours') > reorderMaxAvailableHoursInterval;
};
